export default __webpack_public_path__ + "static/media/Music_17.5b50fbef.png";